import classNames from 'classnames';
import { faDotCircle } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { NSDropdown } from 'bricks';
import { IOptionAnyValue } from 'bricks/types';
import RenderIf from 'components/RenderIf/RenderIf';
import NSRadioCard from 'components/NSRadioCard/NSRadioCard';

export interface IStartFromScratchSectionProps {
    isSelected: boolean;
    onSelect: () => void;
    assetTypeOptions: IOptionAnyValue[];
    proFormaModelId: number | undefined;
    onSelectAssetType: (option: IOptionAnyValue) => void;
}

const StartFromScratchSection = ({
    isSelected,
    onSelect,
    assetTypeOptions,
    proFormaModelId,
    onSelectAssetType,
}: IStartFromScratchSectionProps) => (
    <NSRadioCard
        cardClassName={classNames('p-2 mb-2 NSCard--level-4', {
            'border border-primary': isSelected,
            'border border-secondary': !isSelected,
        })}
        onClick={onSelect}
        dataTestId="start-from-scratch-option"
    >
        <div className="d-flex justify-content-between">
            <div className="text-white mb-1 my-auto">Start from scratch</div>

            <RenderIf isTrue={isSelected}>
                <FontAwesomeIcon icon={faDotCircle} className="text-primary my-auto NSRadioCard__radio-btn--selected" />
            </RenderIf>
            <RenderIf isTrue={!isSelected}>
                <FontAwesomeIcon icon={faCircle} className="my-auto" />
            </RenderIf>
        </div>

        <RenderIf isTrue={isSelected}>
            <div className="h6 mb-0">
                <span className="text-warning">Note:</span>
                {' '}
                Currently, Pro Forma creation is only available for the asset classes
                <br />
                below. If you do not see your asset class, please upload a pro forma instead.
            </div>
            <hr className="my-1" />
            <div className="text-white my-auto d-flex flex-row text-nowrap align-items-center">
                Asset type:
                &nbsp;
                <NSDropdown
                    options={assetTypeOptions}
                    selectedOption={assetTypeOptions.find(option => option.value === String(proFormaModelId))}
                    handleSelectOption={onSelectAssetType}
                    placeholder="Select asset type"
                    containerClassName="w-50"
                    toggleClassName="w-50"
                    dataTestId="asset-type-dropdown"
                />
            </div>
        </RenderIf>
    </NSRadioCard>
);

export default StartFromScratchSection;
